module.exports = __webpack_public_path__ + "static/media/laby.5820379b.jpg";